import * as Yup from 'yup';

export const usePaketeValidation = () => {
  const formValidation = Yup.object({
    name: Yup.string()
      .required('Paketname ist erforderlich')
      .max(100, 'Paketname darf höchstens 100 Zeichen lang sein'),
    duration: Yup.number()
      .required('Dauer ist erforderlich')
      .positive('Dauer muss eine positive Zahl sein'),
    price: Yup.number()
      .required('Preis ist erforderlich')
      .positive('Preis muss eine positive Zahl sein'),
    servicesList: Yup.array()
      .min(1, 'Mindestens ein Service muss hinzugefügt werden'),
    // Unified pricing: no separate holiday price
    longDescription: Yup.string()
      .required('Beschreibung ist erforderlich'),
  });
  return {
    formValidation
  };
};
